module.exports = __webpack_public_path__ + "img/B低通锐化1.6ff76e4a.png";